import { Button, ButtonProps } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttButtonCancelProps = {
    onClick: () => void;
} & ButtonProps;

/**
 * Delete button
 */
export function SttButtonCancel({ onClick, ...rest }: SttButtonCancelProps) {
    const { t } = useTranslation();

    return (
        <Button
            variant="outlined"
            onClick={onClick}
            startIcon={<CloseIcon />}
            {...rest}
        >
            {t('Cancel')}
        </Button>
    );
}
